import { ContainerModule } from '@evertel/di'
import { MessageCTAController } from './controllers/MessageCTAController'

export const DI_WEB_MESSAGE_MODULES = new ContainerModule((m) => {
    m.bind(MessageCTAController).toSelf()
})
